module.exports = __webpack_public_path__ + "img/Frame_10.790c1482.png";